import React from 'react';
import '../../tailwind.css';
import { IEvidenceContainer } from '../../types/EvidenceContainer.types';

const EvidenceContainer: React.FC<IEvidenceContainer> = (props) => {
  return (
    <div
      className="mx-auto flex flex-col justify-center pt-[16px] pb-[96px]"
      id={props.id}
      style={props.style}>
      {props.children}
    </div>
  );
};

export default EvidenceContainer;
